export function getReconciledTotal(state) {
    /*if (state.isBankConciliationDone) {
        return null;
    }*/

    let total = 0;
    const informationExtract =
        state.bankConciliationOperTransactions.informationExtract;
    const accountingInformation =
        state.bankConciliationOperTransactions.accountingInformation;

    const sum1 = informationExtract.reduce((accumulator, currentValue) => {
        const value = parseFloat(currentValue.oper_value);
        if (!isNaN(value)) {
            return accumulator + value;
        }
        return accumulator;
    }, 0);

    const sum2 = accountingInformation.reduce((accumulator, currentValue) => {
        const value = parseFloat(currentValue.operation_value);
        if (!isNaN(value)) {
            return accumulator + value;
        }
        return accumulator;
    }, 0);

    if (sum1 >= sum2) {
        total = sum1 - sum2;
    } else {
        total = sum2 - sum1;
    }

    return total;
}

export function isBankConciliationDone(state) {
    return state.bankConciliationStatus === "conciliados";
}

export function btnIsBankConciliationSuccess(state, getters) {
    const {
        informationExtract,
        accountingInformation
    } = state.bankConciliationOperTransactions;

    return (
        !getters.isBankConciliationDone &&
        informationExtract.length > 0 &&
        accountingInformation.length > 0 &&
        getters.getReconciledTotal === 0
    );
}
export function btnIsBankDesConciliationSuccess(state, getters) {
    const {
        informationExtract,
        accountingInformation
    } = state.bankConciliationOperTransactions;

    return (
        getters.isBankConciliationDone &&
        (informationExtract.length > 0 || accountingInformation.length > 0)
    );
}



// WEBPACK FOOTER //
// ./src/modules/incorporate-bank-statement/getters.js